// extracted by mini-css-extract-plugin
export default {"wrapper":"NumKeyboard_wrapper__T6ug1","invisible":"NumKeyboard_invisible__FXxey","color_primary":"NumKeyboard_color_primary__u4ijR"};